var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-container" }, [
    _vm.gameId
      ? _c("div", {
          staticClass: "game-image lazy",
          attrs: {
            id: _vm.gameId,
            "data-src": _vm.mediaServer(
              "/static/casino/games/" +
                _vm.gameId +
                "/assets/icon/" +
                _vm.gameId +
                "_300x300.jpg"
            )
          },
          on: {
            click: function($event) {
              return _vm.startCasinoLauncher(_vm.gameId)
            }
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebc32704", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc32704","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoGameImage.vue
// module id = null
// module chunks = 